export interface CountryOption { code: string; name: string }

export const COUNTRIES: CountryOption[] = [
  { code: 'CZ', name: 'Česko' },
  { code: 'SK', name: 'Slovensko' },
  { code: 'DE', name: 'Německo' },
  { code: 'AT', name: 'Rakousko' },
  { code: 'PL', name: 'Polsko' },
  { code: 'HU', name: 'Maďarsko' },
  { code: 'GB', name: 'Velká Británie' },
  { code: 'IE', name: 'Irsko' },
  { code: 'US', name: 'Spojené státy' },
  { code: 'AF', name: 'Afghánistán' },
  { code: 'AL', name: 'Albánie' },
  { code: 'DZ', name: 'Alžírsko' },
  { code: 'AD', name: 'Andorra' },
  { code: 'AO', name: 'Angola' },
  { code: 'AG', name: 'Antigua a Barbuda' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AM', name: 'Arménie' },
  { code: 'AU', name: 'Austrálie' },
  { code: 'AZ', name: 'Ázerbájdžán' },
  { code: 'BS', name: 'Bahamy' },
  { code: 'BH', name: 'Bahrajn' },
  { code: 'BD', name: 'Bangladéš' },
  { code: 'BB', name: 'Barbados' },
  { code: 'BE', name: 'Belgie' },
  { code: 'BZ', name: 'Belize' },
  { code: 'BY', name: 'Bělorusko' },
  { code: 'BJ', name: 'Benin' },
  { code: 'BT', name: 'Bhútán' },
  { code: 'BO', name: 'Bolívie' },
  { code: 'BA', name: 'Bosna a Hercegovina' },
  { code: 'BW', name: 'Botswana' },
  { code: 'BR', name: 'Brazílie' },
  { code: 'BN', name: 'Brunej' },
  { code: 'BG', name: 'Bulharsko' },
  { code: 'BF', name: 'Burkina Faso' },
  { code: 'BI', name: 'Burundi' },
  { code: 'CV', name: 'Kapverdy' },
  { code: 'KH', name: 'Kambodža' },
  { code: 'CM', name: 'Kamerun' },
  { code: 'CA', name: 'Kanada' },
  { code: 'CF', name: 'Středoafrická republika' },
  { code: 'TD', name: 'Čad' },
  { code: 'CL', name: 'Chile' },
  { code: 'CN', name: 'Čína' },
  { code: 'CO', name: 'Kolumbie' },
  { code: 'KM', name: 'Komory' },
  { code: 'CG', name: 'Kongo' },
  { code: 'CD', name: 'Demokratická republika Kongo' },
  { code: 'CR', name: 'Kostarika' },
  { code: 'HR', name: 'Chorvatsko' },
  { code: 'CU', name: 'Kuba' },
  { code: 'CY', name: 'Kypr' },
  { code: 'DK', name: 'Dánsko' },
  { code: 'DJ', name: 'Džibutsko' },
  { code: 'DM', name: 'Dominika' },
  { code: 'DO', name: 'Dominikánská republika' },
  { code: 'EC', name: 'Ekvádor' },
  { code: 'EG', name: 'Egypt' },
  { code: 'SV', name: 'Salvador' },
  { code: 'GQ', name: 'Rovníková Guinea' },
  { code: 'ER', name: 'Eritrea' },
  { code: 'EE', name: 'Estonsko' },
  { code: 'SZ', name: 'Svazijsko' },
  { code: 'ET', name: 'Etiopie' },
  { code: 'FJ', name: 'Fidži' },
  { code: 'FI', name: 'Finsko' },
  { code: 'FR', name: 'Francie' },
  { code: 'GA', name: 'Gabon' },
  { code: 'GM', name: 'Gambie' },
  { code: 'GE', name: 'Gruzie' },
  { code: 'GH', name: 'Ghana' },
  { code: 'GI', name: 'Gibraltar' },
  { code: 'GR', name: 'Řecko' },
  { code: 'GD', name: 'Grenada' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'GN', name: 'Guinea' },
  { code: 'GW', name: 'Guinea-Bissau' },
  { code: 'GY', name: 'Guyana' },
  { code: 'HT', name: 'Haiti' },
  { code: 'HN', name: 'Honduras' },
  { code: 'HK', name: 'Hongkong' },
  { code: 'IS', name: 'Island' },
  { code: 'IN', name: 'Indie' },
  { code: 'ID', name: 'Indonésie' },
  { code: 'IR', name: 'Írán' },
  { code: 'IQ', name: 'Irák' },
  { code: 'IL', name: 'Izrael' },
  { code: 'IT', name: 'Itálie' },
  { code: 'CI', name: 'Pobřeží slonoviny' },
  { code: 'JM', name: 'Jamajka' },
  { code: 'JP', name: 'Japonsko' },
  { code: 'JE', name: 'Jersey' },
  { code: 'JO', name: 'Jordánsko' },
  { code: 'KZ', name: 'Kazachstán' },
  { code: 'KE', name: 'Keňa' },
  { code: 'KI', name: 'Kiribati' },
  { code: 'KP', name: 'Severní Korea' },
  { code: 'KR', name: 'Jižní Korea' },
  { code: 'KW', name: 'Kuvajt' },
  { code: 'KG', name: 'Kyrgyzstán' },
  { code: 'LA', name: 'Laos' },
  { code: 'LV', name: 'Lotyšsko' },
  { code: 'LB', name: 'Libanon' },
  { code: 'LS', name: 'Lesotho' },
  { code: 'LR', name: 'Libérie' },
  { code: 'LY', name: 'Libye' },
  { code: 'LI', name: 'Lichtenštejnsko' },
  { code: 'LT', name: 'Litva' },
  { code: 'LU', name: 'Lucembursko' },
  { code: 'MO', name: 'Macao' },
  { code: 'MG', name: 'Madagaskar' },
  { code: 'MW', name: 'Malawi' },
  { code: 'MY', name: 'Malajsie' },
  { code: 'MV', name: 'Maledivy' },
  { code: 'ML', name: 'Mali' },
  { code: 'MT', name: 'Malta' },
  { code: 'MH', name: 'Marshallovy ostrovy' },
  { code: 'MR', name: 'Mauritánie' },
  { code: 'MU', name: 'Mauricius' },
  { code: 'MX', name: 'Mexiko' },
  { code: 'FM', name: 'Mikronésie' },
  { code: 'MD', name: 'Moldavsko' },
  { code: 'MC', name: 'Monako' },
  { code: 'MN', name: 'Mongolsko' },
  { code: 'ME', name: 'Černá Hora' },
  { code: 'MA', name: 'Maroko' },
  { code: 'MZ', name: 'Mosambik' },
  { code: 'MM', name: 'Myanmar' },
  { code: 'NA', name: 'Namibie' },
  { code: 'NR', name: 'Nauru' },
  { code: 'NP', name: 'Nepál' },
  { code: 'NL', name: 'Nizozemsko' },
  { code: 'NZ', name: 'Nový Zéland' },
  { code: 'NI', name: 'Nikaragua' },
  { code: 'NE', name: 'Niger' },
  { code: 'NG', name: 'Nigérie' },
  { code: 'MK', name: 'Severní Makedonie' },
  { code: 'NO', name: 'Norsko' },
  { code: 'OM', name: 'Omán' },
  { code: 'PK', name: 'Pákistán' },
  { code: 'PW', name: 'Palau' },
  { code: 'PS', name: 'Palestina' },
  { code: 'PA', name: 'Panama' },
  { code: 'PG', name: 'Papua-Nová Guinea' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'PE', name: 'Peru' },
  { code: 'PH', name: 'Filipíny' },
  { code: 'PT', name: 'Portugalsko' },
  { code: 'QA', name: 'Katar' },
  { code: 'RO', name: 'Rumunsko' },
  { code: 'RU', name: 'Rusko' },
  { code: 'RW', name: 'Rwanda' },
  { code: 'KN', name: 'Svatý Kryštof a Nevis' },
  { code: 'LC', name: 'Svatá Lucie' },
  { code: 'VC', name: 'Svatý Vincenc a Grenadiny' },
  { code: 'WS', name: 'Samoa' },
  { code: 'SM', name: 'San Marino' },
  { code: 'ST', name: 'Svatý Tomáš a Princův ostrov' },
  { code: 'SA', name: 'Saúdská Arábie' },
  { code: 'SN', name: 'Senegal' },
  { code: 'RS', name: 'Srbsko' },
  { code: 'SC', name: 'Seychely' },
  { code: 'SL', name: 'Sierra Leone' },
  { code: 'SG', name: 'Singapur' },
  { code: 'SI', name: 'Slovinsko' },
  { code: 'SB', name: 'Šalamounovy ostrovy' },
  { code: 'SO', name: 'Somálsko' },
  { code: 'ZA', name: 'Jižní Afrika' },
  { code: 'SS', name: 'Jižní Súdán' },
  { code: 'ES', name: 'Španělsko' },
  { code: 'LK', name: 'Šrí Lanka' },
  { code: 'SD', name: 'Súdán' },
  { code: 'SR', name: 'Surinam' },
  { code: 'SE', name: 'Švédsko' },
  { code: 'CH', name: 'Švýcarsko' },
  { code: 'SY', name: 'Sýrie' },
  { code: 'TW', name: 'Tchaj-wan' },
  { code: 'TJ', name: 'Tádžikistán' },
  { code: 'TZ', name: 'Tanzanie' },
  { code: 'TH', name: 'Thajsko' },
  { code: 'TL', name: 'Východní Timor' },
  { code: 'TG', name: 'Togo' },
  { code: 'TO', name: 'Tonga' },
  { code: 'TT', name: 'Trinidad a Tobago' },
  { code: 'TN', name: 'Tunisko' },
  { code: 'TR', name: 'Turecko' },
  { code: 'TM', name: 'Turkmenistán' },
  { code: 'TV', name: 'Tuvalu' },
  { code: 'UG', name: 'Uganda' },
  { code: 'UA', name: 'Ukrajina' },
  { code: 'AE', name: 'Spojené arabské emiráty' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'UZ', name: 'Uzbekistán' },
  { code: 'VU', name: 'Vanuatu' },
  { code: 'VA', name: 'Vatikán' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'YE', name: 'Jemen' },
  { code: 'ZM', name: 'Zambie' },
  { code: 'ZW', name: 'Zimbabwe' },
];

const TOP_CODES = ['CZ', 'SK', 'DE', 'AT', 'PL', 'HU', 'GB', 'IE', 'US'];

export const COUNTRIES_TOP: CountryOption[] = COUNTRIES.filter((c) => TOP_CODES.includes(c.code))
  .sort((a, b) => TOP_CODES.indexOf(a.code) - TOP_CODES.indexOf(b.code));

export const COUNTRIES_REST: CountryOption[] = COUNTRIES.filter((c) => !TOP_CODES.includes(c.code))
  .sort((a, b) => a.name.localeCompare(b.name, 'cs'));

const CODE_TO_NAME = new Map(COUNTRIES.map((c) => [c.code, c.name]));

export function countryName(code: string | null | undefined): string | null {
  if (!code) return null;
  return CODE_TO_NAME.get(code.toUpperCase()) ?? code;
}
